import { useNavigate } from 'react-router-dom'

import { Box, Button, Text, TextLink } from '@factorialco/deprecated-design-system'
import InvoiceImage from 'assets/images/it-management-invoice-banner.png'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface InvoiceBannerProps {
  urlLink: string
  buttonUrl: string
}

const InvoiceBanner = ({ urlLink, buttonUrl }: InvoiceBannerProps) => {
  const navigate = useNavigate()

  return (
    <Box background="viridian100">
      <Box flexDirection="row" justifyContent="spaceBetween" padding="s24">
        <Box paddingRight="s16" gap="s12">
          <Text.Header2 weight="semibold">
            {i18n.t('software_management.software_setups.details.invoice_banner.title')}
          </Text.Header2>
          <Text.Normal weight="medium">
            {i18n.t('software_management.software_setups.details.invoice_banner.description')}
            <TextLink
              target="_blank"
              to={urlLink}
              onClick={() => {
                track(trackingEvents.softwareManagement.clickOnInvoiceBannerLink)
              }}
            >
              {i18n.t('software_management.software_setups.details.invoice_banner.link_cta')}
            </TextLink>
          </Text.Normal>
          <Button
            onClick={() => {
              track(trackingEvents.softwareManagement.clickOnInvoiceBannerButton)
              navigate(buttonUrl)
            }}
            type="secondary"
          >
            {i18n.t('software_management.software_setups.details.invoice_banner.button_cta')}
          </Button>
        </Box>
        <img alt="invoice banner" width="250px" src={InvoiceImage} />
      </Box>
    </Box>
  )
}

export default InvoiceBanner
